// A practice scorecard: total, pass/fail, each rubric item with its evidence, strengths and fixes.
import type { Scorecard } from '../../../src/shared/api';

export function ScoreBar(props: { score: number; max: number }) {
  const pct = props.max > 0 ? Math.round((props.score / props.max) * 100) : 0;
  const cls = pct >= 80 ? 'ok' : pct < 40 ? 'low' : '';
  return <div class={`tr-bar ${cls}`} role="img" aria-label={`${props.score} of ${props.max}`}><span style={`width:${pct}%`} /></div>;
}

export function ScorecardView(props: { card: Scorecard; compact?: boolean }) {
  const c = props.card;
  return (
    <div class="stack" style="gap:10px">
      <div class="row" style="gap:14px;align-items:center">
        <div class="tr-score">{c.total}</div>
        <div class="stack" style="gap:2px">
          {c.passed ? <span class="chip chip-ok">Pass</span> : <span class="chip chip-bad">Not yet</span>}
          <span class="muted" style="font-size:12px">Pass mark 80, with no invented claims.</span>
          {c.items.some((i) => i.key === 'gatekeeper_intel') ? (
            <span class="muted" style="font-size:12px">Gatekeeper call: the win is the owner's name and best time, so the meeting ask isn't scored.</span>
          ) : null}
        </div>
      </div>
      <table>
        <thead><tr><th>Item</th><th style="width:120px">Score</th>{props.compact ? null : <th>Evidence</th>}</tr></thead>
        <tbody>
          {c.items.map((i) => (
            <tr>
              <td>{i.label}{props.compact ? <div class="muted" style="font-size:12px">{i.evidence}</div> : null}</td>
              <td><div class="row" style="gap:6px"><ScoreBar score={i.score} max={i.max} /><span class="mono">{i.score}/{i.max}</span></div></td>
              {props.compact ? null : <td style="font-size:13px">{i.evidence}</td>}
            </tr>
          ))}
        </tbody>
      </table>
      {c.strengths.length ? (
        <div><div class="eyebrow">What worked</div><ul style="margin:4px 0 0;padding-left:18px">{c.strengths.map((s) => <li>{s}</li>)}</ul></div>
      ) : null}
      {c.fixes.length ? (
        <div><div class="eyebrow">Fix next time</div><ol style="margin:4px 0 0;padding-left:18px">{c.fixes.map((s) => <li>{s}</li>)}</ol></div>
      ) : null}
    </div>
  );
}
